import { precompileTemplate } from "@ember/template-compilation";
export default precompileTemplate("<Home::MwHomeRegistrationPage @model={{this.model}} />",{ moduleName: "mewe/templates/register.hbs" })